import styled, { keyframes } from 'styled-components';

import { fadeIn } from '../../../styles/shared.style';

const hexToRgba = (hex: string, opacity: number) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

export const Wrapper = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 40px;
    padding: 16px 0;
`;

export const TextInfo = styled.span<{$align: 'center' | 'left'}>`
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    color: ${({ theme }) => theme.colors.text.secondary};
    text-align: ${({ $align }) => $align};
    width: 400px;
    margin-top: -10px;
    margin-bottom: -10px;
    animation: ease-out, ${fadeIn} 0.5s ease-out;
`;

export const Spinner = styled.svg`
  width: 40px;
  height: 40px;
  animation: ${rotate} 2s linear infinite;
  
  & .path {
    stroke: ${({ theme }) => theme.colors.accent.primary};
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`;

export const WrapperButton = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: -20px;
    gap: 0.8rem;
    animation: ease-out, ${fadeIn} 0.5s ease-out;
`;

export const Button = styled.button<{$type: 'filled' | 'alpha'}>`
    height: 40px;
    border-radius: 50px;
    padding: 0 20px;

    background-color: ${({ theme, $type }) => $type === 'filled'
    ? theme.colors.accent.primary
    : hexToRgba(theme.colors.accent.primary, 0.2)};
    color: ${({ theme, $type }) => $type === 'filled'
    ? theme.colors.text.inverted
    : theme.colors.accent.primary};

    &:hover {
        background-color: ${({ theme, $type }) => $type === 'filled'
    ? theme.colors.accent.primary
    : hexToRgba(theme.colors.accent.primary, 0.2)};
    }

    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    text-align: center;

`;
